import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { IamService } from "src/app/core/apis/iam/api/api";
import { UsuarioService } from "src/app/core/apis/orchestrador/api/usuario.service";
import { UserAccountsService } from "src/app/core/apis/user-accounts/api/api";
import { Globals } from "src/app/core/helpers/globals";
import { SessionService } from "src/app/core/service/session.service";

@Component({
    selector: "app-login-identifique",
    template: "",
    styleUrls: ["./login-identifique.component.css"],
    standalone: true,
})
export class LoginIdentifiqueComponent implements OnInit {
  credential;
  cargo;
  usuario;
  message: string;
  tokenIdentifique;
  bearerToken;

  constructor(
    private globals: Globals,
    private tipoUsuarioService: UsuarioService,
    private iamService: IamService,
    private route: ActivatedRoute,
    private userAccountService: UserAccountsService,
    private sessionService: SessionService,
    private router: Router
  ) {}

  ngOnInit() {
    this.globals.addToLoading("login-identifique");
    this.tokenIdentifique = sessionStorage.getItem("tokenIdentifique");
    this.bearerToken = sessionStorage.getItem("BearerToken");
    this.credential = this.route.snapshot.queryParams["credential"];
    this.getTokenJWTIam();
  }

  getUsuarioCertificado(JWtToken) {
    this.userAccountService.authFindUserById(JWtToken).subscribe(
      (response) => {
        this.usuario = response.body;
        sessionStorage.setItem("usuario", JSON.stringify(this.usuario));
        this.getTipoUsuario(JWtToken);
      },
      (error) => {
        this.globals.showSnackBar(
          "Erro ao carregar dados do certificado digital do usuario, contate o administrador do sistema!"
        );
        console.error("Erro api: ", error);
      }
    );
  }

  getTipoUsuario(tokenJWT) {
    this.tipoUsuarioService.consultarTipoUsuario(tokenJWT).subscribe(
      (response) => {
        sessionStorage.setItem("cargo", response.body.tipoUsuario);
        this.router.navigate(["/ordem"]);
      },
      (error) => {
        this.globals.showSnackBar(
          "Erro ao validar usuario cadastrado no sistema, vamos reprocessar a requisição novamente por favor aguarde, se o problema persistir por favor entrar em contato com administrador."
        );

        setTimeout(() => {
          window.location.href = "/error?type=permission";
        }, 4000);
        console.error("Erro api: ", error);
      }
    );
  }

  getTokenJWTIam() {
    this.iamService
      .authStrong(this.bearerToken, this.tokenIdentifique, this.credential)
      .subscribe(
        (response) => {
          let JWtToken = response.body.accessToken;
          sessionStorage.setItem("JWTToken", JWtToken);
          this.getUsuarioCertificado(JWtToken);
          this.sessionService.notifySessionTimeUpdated();
        },
        (error) => {
          this.globals.showSnackBar(
            "Erro ao gerar token JWT de validação, contate o administrador do sistema!"
          );
          console.error("Erro api: ", error);
          setTimeout(() => {
            window.location.href = "/error";
          }, 4000);
        }
      );
  }
}
